/**
 * External dependencies
 */
import React, { useState } from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { TowerProvider } from "@towersystems/towersystems-design-system";
import { Text } from "components/text";

/**
 * Internal dependencies
 */

import { ButtonV2 } from "components/button-v2";
import ButtonGroup from "components/button-group";

/**
 * Style dependencies
 */
import "./styles.scss";

const SetDefaultPrompt = ({
  dashboardId,
  onClose,
  message,
  title,
  ...props
}) => {
  const [saving, setSaving] = useState(false);

  return (
    <TowerProvider>
      <Box className="react-confirm-alert-body">
        <Box align="center">
          <Text variant="headingXs" size="large" weight="medium" align="center">
            {title}
          </Text>
        </Box>
        <Box size="medium" align="center">
          {message}
        </Box>
        <Box marginTop="xlarge">
          <div className="flex gap-3 justify-center">
            <ButtonV2
              onClick={async () => {
                setSaving(true);
                await props.savePreference("defaultDashboard", dashboardId);
                onClose();
              }}
              variant="primary"
              disabled={saving}
            >
              Yes, set default!
            </ButtonV2>
            <ButtonV2 onClick={onClose}>Cancel</ButtonV2>
          </div>
        </Box>
      </Box>
    </TowerProvider>
  );
};

export default SetDefaultPrompt;
